export default __webpack_public_path__ + "static/media/img3.6ec15e0f.svg";